import { render, staticRenderFns } from "./registroSaldoInicial.vue?vue&type=template&id=3e4a8be8&lang=pug&"
import script from "./registroSaldoInicial.vue?vue&type=script&lang=js&"
export * from "./registroSaldoInicial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports